export default {
      id: "add-patient-success-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#add-patient-success",
      toString: function () {
        return this.url;
      }
    }